import { useState } from 'react'
import { FaStar } from 'react-icons/fa'
import './StarRating.css'

/**
 * Stars, either to read or to choose.
 *
 * Reading shows halves, because an average of 4.5 should not round away the
 * half a student earned. Choosing does not: a rating is a whole number.
 */
const StarRating = ({ value = 0, onChange = null, size = 'md' }) => {
  const [hovered, setHovered] = useState(0)
  const interactive = typeof onChange === 'function'
  const shown = interactive && hovered ? hovered : value

  const stars = [1, 2, 3, 4, 5].map((star) => {
    // A star is full at or below the value, half when the value falls inside
    // it, empty above. Halves are only meaningful when reading.
    const fill = shown >= star ? 1 : !interactive && shown > star - 1 ? shown - (star - 1) : 0

    return (
      <button
        key={star}
        type="button"
        className={`star-rating-star ${interactive ? 'is-interactive' : ''}`}
        onClick={interactive ? () => onChange(star) : undefined}
        onMouseEnter={interactive ? () => setHovered(star) : undefined}
        onMouseLeave={interactive ? () => setHovered(0) : undefined}
        disabled={!interactive}
        aria-label={`${star} من 5`}
      >
        <FaStar className="star-rating-base" />
        {fill > 0 && (
          // Clipped rather than a second icon, so a half star lines up exactly
          // with the outline beneath it.
          <span className="star-rating-fill" style={{ width: `${fill * 100}%` }}>
            <FaStar />
          </span>
        )}
      </button>
    )
  })

  return (
    <div
      className={`star-rating star-rating-${size}`}
      role={interactive ? 'radiogroup' : 'img'}
      aria-label={interactive ? 'اختر تقييمك' : `التقييم ${value} من 5`}
    >
      {stars}
    </div>
  )
}

export default StarRating
